import { render } from "./TaskClockDrawing.vue?vue&type=template&id=c0f5a608"
import script from "./TaskClockDrawing.vue?vue&type=script&lang=js"
export * from "./TaskClockDrawing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__